<template>
  <div class="h5-container">
    <van-nav-bar
        class="top-bar"
        title="权益中心"
        left-text="返回"
        left-arrow
        @click-left="onClickLeft"
    ></van-nav-bar>

    <div class="container-item">
      <van-tabs
          v-model="activeTab"
          swipeable
          sticky
          ellipsis
          title-active-color="#B8860B"
          title-inactive-color="#FFFFFF"
          line-color="#B8860B"
          class="rights-tabs"
      >
        <van-tab v-for="item in equitiesList" :title="item.equitiesName" :key="item.equitiesId">
          <div class="tab-content">
            <van-card
                v-for="(child,inx) in item.children"
                :key="inx"
                class="rights-card"
            >
              <template #title>
                <div class="custom-title">
                  <span class="badge">{{item.equitiesName}}券</span>
                </div>
              </template>
              <template #desc>
                <div class="custom-desc">
                  <h3>{{child.brandName}}</h3>
                  <h3>{{child.seriesName || '暂无系列名称'}}</h3>

                  <!-- 按钮同行布局：查看回寄信息 + 立即使用 -->
                  <div class="btn-row">
                    <van-button size="small" type="default" @click="goToInfo()" :loading="infoLoading">
                      查看回寄信息
                    </van-button>
                    <van-button size="small" type="primary" style="color: #fff" @click="handleUseRight(child,child.seriesId,item.equitiesId,item.equitiesName)">
                      立即使用
                    </van-button>
                  </div>

                </div>
              </template>
              <template #footer>
                <p style="color: #1A1A1A;text-align: left">权益摘要：{{item.equityDesc}}</p>
              </template>
            </van-card>
          </div>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
import '@/assets/css/mobileGlobal.scss';
import {memberEquities, memberEquitiesUse, shippingAddress} from "@/api/mine";
import {Dialog} from "vant";
export default {
  data() {
    return {
      activeTab: 0,
      equitiesList: [],
      clubValue: '',
      infoLoading: false, // 查看回寄信息按钮loading
    };
  },
  created() {
    this.clubValue = this.$route.query.clubValue || '';
    this.memberEquities();
  },
  methods: {
    onClickLeft() {
      if(this.clubValue){
        this.$router.push('/app_myClub');
      }else {
        this.$router.push('/app_home');
      }

    },

    // 查看回寄信息 —— 接口请求后弹框显示
    async goToInfo() {
      this.infoLoading = true;
      try {
        const res = await shippingAddress(this.clubValue);
        if (res.code === 200 && res.data) {
          const { consignee, phone, area, address } = res.data;
          Dialog.alert({
            title: '回寄地址信息',
            messageAlign: 'left', // 内容左对齐
            dangerouslyUseHTMLString: true,
            message: `
              收货人：${consignee || '--'}<br/>
              手机号：${phone || '--'}<br/>
              所在地区：${area || '--'}<br/>
              详细地址：${address || '--'}
            `,
            style: { width: '90%', maxWidth: 'none' }
          });
        } else {
          Dialog.alert({ title: '提示', message: res.returnMsg || '获取回寄地址失败' });
        }
      } catch (err) {
        console.error(err);
        Dialog.alert({ title: '错误', message: '网络异常，请稍后重试' });
      } finally {
        this.infoLoading = false;
      }
    },

    async memberEquitiesUse(type,seriesId){
      return await new Promise((resolve) => {
        memberEquitiesUse(type,seriesId,this.clubValue).then(res => {
          if (res.code === 200) {
            resolve(true);
          } else {
            this.showDialogMsg(res.returnMsg);
            resolve(false);
          }
        })
      })
    },

    async handleUseRight(child,seriesId,type,typeName) {
      const equityIntro = child.children[0].equityIntro || ''
      const equityId = child.children[0].id || ''
      console.log(111,equityId);
      //喷漆走售后申请
      if (type === '5') {
        const flag = await this.memberEquitiesUse(type,seriesId);
        if (flag) {
          this.$router.push({
            path:'/app_after_benefits',
            query:{
              equityId: equityId,
              equityIntro: equityIntro,
              clubValue: this.clubValue,
              brand: this.$route.query.brand || '',
              brandCode: this.$route.query.brandCode || '',
              model: this.$route.query.model || '',
              modelCode: this.$route.query.modelCode || '',
            }
          });
        }

      }else{
        this.$router.push({
          path:'/benefits_use',
          query:{
            seriesId: seriesId,
            type: type,
            typeName: typeName,
            clubValue: this.clubValue
          }
        });
      }

    },
    async memberEquities(){
      try {
        const res = await memberEquities();
        if (res.code === 200 && res.data) {
          this.equitiesList = res.data.equities || [];
        } else {
          Dialog.alert({ title: "提示", message: res.returnMsg || "获取权益数据失败" });
        }
      } catch (err) {
        console.error("获取会员权益失败：", err);
        Dialog.alert({ title: "错误", message: "网络异常，请稍后重试" });
      }
    },
    showDialogMsg(message){
      Dialog.alert({
        title: '提示',
        message: message,
        dangerouslyUseHTMLString: true,
        style: { width: '90%', maxWidth: 'none' }
      });
    }
  },
};
</script>

<style scoped lang="scss">
.h5-container {
  min-height: 100vh;
  background-color: #1A1A1A;
  padding: 0 16px;
  box-sizing: border-box;
}

::v-deep .van-tabs .van-tabs__nav {
  background-color: #1A1A1A !important;
}
::v-deep .van-tab__text{
  color: #FFFFFF !important;
}
::v-deep .van-tab--active .van-tab__text{
  color: #B8860B !important;
}

::v-deep .van-card {
  background: #FFFFFF !important;
  border: none !important;
  padding: 15px !important;
}

.top-bar {
  background: linear-gradient(135deg, #D4AF37 0%, #B8860B 100%);
  margin: 0 -16px;
  height: 46px;
  line-height: 46px;

  ::v-deep .van-nav-bar__title {
    color: #0f0f0f;
    font-weight: bold;
    font-size: 16px;
  }

  ::v-deep .van-icon-arrow-left,
  ::v-deep .van-nav-bar__text {
    color: #0f0f0f !important;
    font-size: 14px;
  }

  ::v-deep .van-nav-bar__content {
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }
}

.container-item {
  padding: 10px 0;

  ::v-deep .rights-tabs {
    .van-tabs__wrap {
      background-color: #1A1A1A !important;
      padding-top: 5px;
    }

    .van-tab {
      font-size: 14px;
    }

    .van-tabs__content {
      padding: 10px 0;
      background-color: #1A1A1A;
    }
  }
}

.tab-content {
  padding: 0 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.rights-card {
  background-color: #fff !important;
  border-radius: 8px;
  overflow: hidden;

  ::v-deep .van-card__title {
    padding: 0 !important;
    margin-bottom: 10px !important;
    font-size: 15px;
    color: #333;
    font-weight: 500;
    line-height: 1.5;
  }

  ::v-deep .van-card__desc {
    padding: 0 !important;
    margin: 0 !important;
    font-size: inherit !important;
    color: inherit !important;
    line-height: 1.5 !important;
    overflow: visible !important;
  }

  ::v-deep .van-card__footer {
    justify-content: flex-end;
    padding: 10px 0 0 0 !important;
    border-top: 1px solid #eee;
    margin-top: 10px;
  }
}

.custom-title {
  position: relative;
  min-height: 20px;
  padding-left: 60px;
}

.badge {
  position: absolute;
  left: 0;
  top: 0;
  background-color: red;
  color: white;
  padding: 2px 5px;
  border-radius: 3px;
  font-size: 12px;
  line-height: 1.2;
}

.custom-desc {
  h3 {
    margin: 0 ;
    padding-top: 10px;
    font-size: 14px;
    color: #333 ;
    font-weight: 600 ;
    line-height: 1.4;
  }
  p{
    padding-top: 10px;
    font-size: 12px;
    color: #525252;
  }
}

// 按钮同行布局（新增）
.btn-row {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 10px;
}

.mt-10 {
  margin-top: 10px;
}
</style>